import React, { PropTypes } from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { Route, IndexRedirect, Redirect } from 'react-router'
import { utils, consts, components, Session, Settings } from 'unity-core'
import { Home, Login, SSOLanding, SSOError, Modules } from 'components'
import { App } from 'containers'
const { userUtils } = utils
import * as loader from 'loader'
const { Routes } = consts
import { UserAuthWrapper } from 'redux-auth-wrapper'
import { routerActions } from 'react-router-redux'
import { Actions as actions } from 'unity-core'
import { connect } from 'react-redux'
import loadable from 'loadable-components'
const { Loader } = components

const propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  modules: PropTypes.object
}
const defaultProps = {}

//https://github.com/mjrussell/redux-auth-wrapper
//-----------------------------------------------
const authWrapper = UserAuthWrapper({
  authSelector: state => state.user,
  authenticatingSelector: state => state.user.isAuthenticating,
  predicate: user => userUtils.IsAuthenticated(user), //on false, browser will redirect to the 'failureRedirectPath' path
  redirectAction: routerActions.replace,
  // redirectAction: (newLoc) => (dispatch) => {
  //   dispatch(routerActions.relplace(newLoc))
  //   dispatch(addNotification({ message: 'Sorry, you are not an administrator' }));
  // },
  failureRedirectPath: '/login',
  allowRedirectBack: true,
  wrapperDisplayName: 'UserIsAuthenticated'
})
const Authenticated = authWrapper(props => props.children)

export class Root extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    this.props.refreshAppUpdates([])
  }

  render() {
    const { store, history, user, modules, updating } = this.props
    const onEnterLogin = (nextState, replace) => {
      const { user } = store.getState()
      if (userUtils.IsAuthenticated(user)) {
        replace(`/${Routes.HOME}`)
      }
    }

    return (
      <Loader loaded={!updating && modules != null}>
        <div className="header-fixed has-sidebar sidebar-fixed">
          <Provider store={store}>
            <Router history={history}>
              <Route path='/' component={App}>
                <IndexRedirect to={Routes.LOGIN} />
                <Route path={'legacy-login'} component={Login} onEnter={onEnterLogin} />
                <Route path={'login-error'} component={SSOError} onEnter={onEnterLogin} />
                <Route path={Routes.LOGIN} component={SSOLanding} onEnter={onEnterLogin} />

                <Route component={Authenticated}>

                  {/* HOME SELECT APP / MODULE */}
                  <IndexRedirect to={Routes.HOME} />
                  <Route path={Routes.HOME} component={Home} />
                  <Route path={Routes.SESSION} component={Session} />
                  <Route path={Routes.SETTINGS} component={Settings} />

                  {/* UBET MODULE */}
                  {/* <Route path={Routes.MODULES.UBET} component={Modules.UBet}>
                    <IndexRedirect to={Routes.UBET.launcher} />
                    <Route path={Routes.UBET.launcher} component={Modules.UBet} />
                  </Route> */}

                  {
                    _.map(_.filter(modules, x => x.enabled && !x.external), m => {
                      return <Route key={m.bundle} path={m.path}
                        getIndexRoute={(loc, cb) => loader.loadModuleIndexRoute(m, loc, cb)}
                        getChildRoutes={(loc, cb) => loader.loadModuleChildRoutes(m, loc, cb)} />
                    })
                  }

                  <Route path='*' exact={true} component={() => <center><h2>Page Not Found</h2></center>} />
                </Route>
              </Route>
            </Router>
          </Provider>
        </div>
      </Loader>
    )
  }
}

Root.propTypes = propTypes
Root.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  modules: state.app.modules,
  updating: state.app.updating,
  user: state.user
})
const mapDispatchToProps = (dispatch) => ({
  refreshAppUpdates: (x) => dispatch(actions.App.refreshAppUpdates(x))
})

export default connect(mapStateToProps, mapDispatchToProps)(Root)

